import React from 'react';
import Styles from '../ClubSpecs.module.scss';

const PutterSpec = (props) => {
  const { clubItem, getFormattedDate } = props;
  const { attributes } = clubItem;

  return (
    <>
      {clubItem?.enterDate && (
        <div className={Styles.specItem}>
          BUILD DATE:
          <span className={Styles.specValue}>
            {getFormattedDate(new Date(clubItem.enterDate))}
          </span>
        </div>
      )}
      {attributes?.head && (
        <div className={Styles.specItem}>
          HEAD:
          <span className={Styles.specValue}>{attributes.head}</span>
        </div>
      )}
      {attributes?.model && (
        <div className={Styles.specItem}>
          MODEL:
          <span className={Styles.specValue}>{attributes.model}</span>
        </div>
      )}
      {attributes?.modelcolor && (
        <div className={Styles.specItem}>
          MODEL COLOR:
          <span className={Styles.specValue}>{attributes.modelcolor}</span>
        </div>
      )}
      {attributes?.facecolor && (
        <div className={Styles.specItem}>
          FACE COLOR:
          <span className={Styles.specValue}>{attributes.facecolor}</span>
        </div>
      )}
      {attributes?.finish && (
        <div className={Styles.specItem}>
          FINISH:
          <span className={Styles.specValue}>{attributes.finish}</span>
        </div>
      )}
      {attributes?.goldplating && (
        <div className={Styles.specItem}>
          GOLD PLATING:
          <span className={Styles.specValue}>{attributes.goldplating}</span>
        </div>
      )}
      {attributes?.dexterity && (
        <div className={Styles.specItem}>
          DEXTERITY:
          <span className={Styles.specValue}>{attributes.dexterity}</span>
        </div>
      )}
      {attributes?.loft && (
        <div className={Styles.specItem}>
          LOFT:
          <span className={Styles.specValue}>{attributes.loft}</span>
        </div>
      )}
      {attributes?.lie && (
        <div className={Styles.specItem}>
          LIE:
          <span className={Styles.specValue}>{attributes.lie}</span>
        </div>
      )}
      {attributes?.shaft && (
        <div className={Styles.specItem}>
          SHAFT:
          <span className={Styles.specValue}>{attributes.shaft}</span>
        </div>
      )}
      {attributes?.shaftflex && (
        <div className={Styles.specItem}>
          SHAFT FLEX:
          <span className={Styles.specValue}>{attributes.shaftflex}</span>
        </div>
      )}
      {attributes?.length && (
        <div className={Styles.specItem}>
          LENGTH:
          <span className={Styles.specValue}>{attributes.length}</span>
        </div>
      )}
      {attributes?.grip && (
        <div className={Styles.specItem}>
          GRIP:
          <span className={Styles.specValue}>{attributes.grip}</span>
        </div>
      )}
      {attributes?.bend && (
        <div className={Styles.specItem}>
          BEND:
          <span className={Styles.specValue}>{attributes.bend}</span>
        </div>
      )}
      {attributes?.line && (
        <div className={Styles.specItem}>
          LINE:
          <span className={Styles.specValue}>{attributes.line}</span>
        </div>
      )}
      {attributes?.swingweight && (
        <div className={Styles.specItem}>
          SWING WEIGHT:
          <span className={Styles.specValue}>{attributes.swingweight}</span>
        </div>
      )}
      {attributes?.weightoption && (
        <div className={Styles.specItem}>
          WEIGHT OPTION:
          <span className={Styles.specValue}>{attributes.weightoption}</span>
        </div>
      )}
      {attributes?.logoetchingtype && (
        <div className={Styles.specItem}>
          LOGO ETCHING TYPE:
          <span className={Styles.specValue}>{attributes.logoetchingtype}</span>
        </div>
      )}
      {attributes?.textetchingfont && (
        <div className={Styles.specItem}>
          TEXT ETCHING FONT:
          <span className={Styles.specValue}>{attributes.textetchingfont}</span>
        </div>
      )}
    </>
  );
};

export default PutterSpec;
